import { useTenantBrandingContext } from "@/context/TenantBrandingProvider";
import type { TenantBrandingIdentity } from "@/utils/tenant-branding-cache";

/** Tenant display fields from `GET /tenant-branding/me`, cached in sessionStorage. */
export function useTenantBranding(): TenantBrandingIdentity {
  return useTenantBrandingContext().identity;
}
